'use client';

import { forwardRef } from '@ironhack/design-system2/components/forward-ref';
import { type LinkProps } from '@ironhack/design-system2/components/link';
import { Logo } from '@ironhack/design-system2/components/logo';
import { type As } from '@ironhack/design-system2/types';
import { type ReactElement } from 'react';
import { type Merge } from 'type-fest';

import { Link } from '@/app/components/client/link';
import { type NavbarQuery } from '@/app/components/server/navbar/types';

type Props = Merge<
  LinkProps,
  {
    color?: 'text.inverse' | 'text.primary';
    data: Pick<NavbarQuery, 'navbar'>;
  }
>;

// Needs forwardRef so RegionSuggestion can inject a ref for PopoverTrigger
export const IronhackLogoLink = forwardRef<Props, As>(
  (props: Props, ref): ReactElement => {
    const { color = 'text.inverse', data, ...boxProps } = props;
    const {
      navbar: {
        logoTarget: [logoTarget],
      },
    } = data;

    return (
      <Link
        {...logoTarget}
        alignItems="center"
        aria-label="Ironhack Home Page"
        display="flex"
        ref={ref}
        {...boxProps}
      >
        <Logo
          colorScheme={color === 'text.inverse' ? 'light' : 'dark'}
          height="20px"
          layout="full"
          width="125px"
        />
      </Link>
    );
  }
);
